module.exports = __webpack_public_path__ + "img/mascot-change-pass.8c018c6d.svg";